import * as tslib_1 from "tslib";
import { Item } from './item';
import { Value } from './value';
import { Cursor } from './cursor';
var Absent = (function (_super) {
    tslib_1.__extends(Absent, _super);
    function Absent() {
        return _super.call(this) || this;
    }
    Absent.prototype.isDefined = function () {
        return false;
    };
    Absent.prototype.isDistinct = function () {
        return false;
    };
    Absent.prototype.isEmpty = function () {
        return true;
    };
    Absent.prototype.concat = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var record = Value.empty();
        for (var i = 0, n = items.length; i < n; i += 1) {
            items[i].forEach(function (item) {
                record.push(item);
            });
        }
        return record;
    };
    Absent.prototype.withField = function (key, newValue) {
        return Value.empty(1).withField(key, newValue);
    };
    Absent.prototype.withAttr = function (key, newValue) {
        return Value.empty(1).withAttr(key, newValue);
    };
    Absent.prototype.withSlot = function (key, newValue) {
        return Value.empty(1).withSlot(key, newValue);
    };
    Absent.prototype.withItem = function (newItem) {
        return Value.empty(1).withItem(newItem);
    };
    Absent.prototype.forEach = function (callback, thisArg) {
        return undefined;
    };
    Absent.prototype.iterator = function () {
        return Cursor.Empty;
    };
    Absent.prototype.cond = function (thenTerm, elseTerm) {
        elseTerm = Item.of(elseTerm);
        return elseTerm;
    };
    Absent.prototype.or = function (that) {
        that = Item.of(that);
        return that;
    };
    Absent.prototype.and = function (that) {
        return this;
    };
    Absent.prototype.not = function () {
        return Value.Extant;
    };
    Absent.prototype.booleanValue = function () {
        return false;
    };
    Absent.prototype.toAny = function () {
        return undefined;
    };
    Absent.prototype.valueOf = function () {
        return undefined;
    };
    Absent.prototype.writeRecon = function (output) {
    };
    Absent.prototype.toRecon = function () {
        return '';
    };
    Absent.prototype.toReconBlock = function () {
        return '';
    };
    Absent.prototype.compare = function (that) {
        if (that instanceof Absent) {
            return 0;
        }
        else {
            return 1;
        }
    };
    Absent.prototype.equals = function (that) {
        return this === that;
    };
    Absent.prototype.hashCode = function () {
        return 0xF7C00CCE;
    };
    Absent.prototype.toString = function () {
        return 'absent';
    };
    return Absent;
}(Value));
export { Absent };
Item.Absent = new Absent();
Value.Absent = Item.Absent;
//# sourceMappingURL=data:application/json;base64,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